import apisauce from 'apisauce';
import ApiMonitor from './apiMonitor';
import AppConfig from '../../config/appConfig';

const create = () => {
    /* eslint-disable prefer-template */
    /* eslint-enable prefer-template */
    // define the api
    const caravansApi = apisauce.create({
        baseURL: AppConfig.apiUrl,
        headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        timeout: 10000,
        mode: 'no-cors',
    });

    // Wrap api's addMonitor to allow the calling code to attach
    // additional monitors in the future.  But only in __DEV__ and only
    // if we've attached Reactotron to console (it isn't during unit tests).
    if (AppConfig.isDevelopmentMode && console.tron) {
        caravansApi.addMonitor(console.tron.apisauce);
    }

    // Add some monitors for the request connection. Also shows alerts with the best
    // matching message.
    ApiMonitor(caravansApi);

    // Define some functions that call the api.  The goal is to provide
    // a thin wrapper of the api layer providing nicer feeling functions
    // rather than "get", "post" and friends.
    //
    // I generally don't like wrapping the output at this level because
    // sometimes specific actions need to be take on `403` or `401`, etc.
    //
    // Since we can't hide from that, we embrace it by getting out of the
    // way at this level.
    //
    const getCaravan = (identifier, locale) => caravansApi.get('caravans', { caravan: identifier, L: locale });
    const listCaravans = (locale) => caravansApi.get('caravans', { L: locale });

    return {
        getCaravan,
        listCaravans,
    };
};

export default {
    create,
};
